import { render } from "./MarkdownContent.vue?vue&type=template&id=6d609c43&scoped=true&ts=true"
import script from "./MarkdownContent.vue?vue&type=script&lang=ts"
export * from "./MarkdownContent.vue?vue&type=script&lang=ts"

import "./MarkdownContent.vue?vue&type=style&index=0&id=6d609c43&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d609c43"]])

export default __exports__